import { styled as o } from "styled-components";
import { Icon as r } from "../../../../components/Icon/index.js";
import { Theme as t } from "../../../../styles/themes/index.js";
import { Dropdown as m } from "../../../Dropdown/index.js";
import { MediaQuery as i } from "../../../../styles/variables.js";
const d = o(r)`
  font-size: 18px;
  color: rgb(${t.colors.Alpha});
`, f = o(m.List)`
  @media ${i.SCREEN_MD_UP} {
    width: 375px;
  }
`;
export {
  d as CommentOptionsIcon,
  f as CustomDropdownList
};
